module.exports = __webpack_public_path__ + "static/masonry-image-4-7a89105bdc4add6109de79f45190b77d.jpg";